import { ConfigProvider, Space, Tooltip, Typography } from "antd"

const { Text } = Typography

export const UserTooltip = ({ record, children }) => {
  return (
    <Tooltip
      styles={{ root: { maxWidth: '30em' } }}
      placement='left'
      mouseEnterDelay={0.3}
      title={
        <ConfigProvider
          theme={{
            components: {
              Typography: {
                colorText: 'inherit', // Establece el color del texto que el tooltip le hereda
              },
            },
          }}
        >
          <Space direction='vertical' size={0}>
            <Text>
              <Text strong>Nombre:</Text> {`${record.firstName} ${record.lastName}`}
            </Text>
            <Text>
              <Text strong>Correo:</Text> {record.email || <Text italic>Sin correo</Text>}
            </Text>
            <Text>
              <Text strong>Perfil:</Text> {record.profile.name || <Text italic>Sin perfil</Text>}
            </Text>
            {record.advisor && ( // Solo muestra el vendedor si existe
              <Text>
                <Text strong>Vendedor:</Text> {record.advisor.name || <Text italic>Sin nombre</Text>}
              </Text>
            )}
          </Space>
        </ConfigProvider>
      }
    >
      {children}
    </Tooltip>
  )
}